/* eslint-disable */
/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import {enquireScreen} from 'enquire-js';
import TextCon from '../components/TextCon';
import Banner3 from './Banner3';
import Feature3 from './Feature3';
import Feature1 from './Feature1';
import Detail from './Detail';


import {
    Banner30DataSource,
    Feature30DataSource,
    Feature10DataSource, PositionList,
} from './data.source';
import './less/antMotionStyle.less';
import Footer1 from "../Home/Footer1";
import Nav0 from "../Home/Nav0";
import {Footer10DataSource,Nav00DataSource} from "../Home/data.source";
import BreadcrumbCon from "../components/BreadcrumbCon";

let isMobile;
enquireScreen((b) => {
    isMobile = b;
});

const {location} = window;

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile,
            // show: !location.port, // 如果不是 dva 2.0 请删除
            showDetail: false,
            ix: 0,

        };
    }

    componentWillMount() {

    }

    componentDidMount() {
        // 适配手机屏幕;
        enquireScreen((b) => {
            this.setState({isMobile: !!b});
        });
        // dva 2.0 样式在组件渲染之后动态加载，导致滚动组件不生效；线上不影响；
        /* 如果不是 dva 2.0 请删除 start */


        /*  if (location.port) {
         // 样式 build 时间在 200-300ms 之间;
         setTimeout(() => {
         this.setState({
         show: true,
         });
         }, 500);
         }*/
        /* 如果不是 dva 2.0 请删除 end */

        //延迟下滑才起作用，原因不清楚；
        setTimeout(() => {
            this.scroll();
        }, 1000);
    }

    showDetail(ix) {
        this.setState({showDetail: true, ix: ix,});
    }

    scroll() {
        let key = window.location.hash.split("?")[1];
        let eleId = '';
        switch (key) {
            case 'key=1':
                eleId = 'container111';
                break;
            case 'key=2':
                eleId = 'Feature3_0';
                break;
            default:
                eleId = '';
                break;
        }
        console.log('eleId', eleId);
        let anchorElement = document.getElementById(eleId);
        if (anchorElement) {
            anchorElement.scrollIntoView(
                {behavior: 'smooth'}
            );
        }
    }

    render() {
        const {showDetail, ix,} = this.state;
        const children = [
            <Nav0
                id="Nav0_0"
                key="Nav0_0"
                dataSource={Nav00DataSource}
                isMobile={this.state.isMobile}
            />,
            <Banner3
                id="Banner3_0"
                key="Banner3_0"
                dataSource={Banner30DataSource}
                isMobile={this.state.isMobile}
            />,
            <div className={"container"}
                 id="container111"
                 style={{height: '8vh',paddingTop:"40px"}}>
                <BreadcrumbCon pageName={"人才战略"} pagePath={"/talentStrategy"}/>
            </div>,
            <br/>,
            <div className={"container"}>
                <TextCon title={"人才战略 / talentStrategy"}
                />
            </div>,
            <div style={{
                margin: ' 0 auto 64px', marginBottom: 0,
                paddingTop: '0', textAlign: 'center', backgroundColor: '#f3f4f6',
            }}>
            </div>,
            <Feature1
                id="Feature1_0"
                key="Feature1_0"
                dataSource={Feature10DataSource}
                isMobile={this.state.isMobile}
                style={{minHeight:"40vh"}}
            />,
            <Feature3
                id="Feature3_0"
                key="Feature3_0"
                dataSource={Feature30DataSource}
                isMobile={this.state.isMobile}
                showDetail={this.showDetail.bind(this)}
            />,
            <Footer1
                id="Footer1_0"
                key="Footer1_0"
                dataSource={Footer10DataSource}
                isMobile={this.state.isMobile}
            />,
        ];

        let object = PositionList[ix];
        const childrenDetail = [
            <Banner3
                id="Banner3_0"
                key="Banner3_0"
                dataSource={Banner30DataSource}
                isMobile={this.state.isMobile}
            />,
            <div className={"container"}
                 style={{height: '5vh',}}>
                <BreadcrumbCon pageName={"人才战略"} pagePath={"/talentStrategy"}/>
            </div>,
            <div className={"container"}
                 style={{minHeight: '50vh',}}>
                <Detail
                    title={object ? object['title'] : ""}
                    feTitle={object ? object['feTitle'] : ""}
                    position={object ? object['position'] : ""}
                    responsibility={object ? object['responsibility'] : ""}
                    require={object ? object['require'] : ""}
                    backUp={() => this.setState({showDetail: false})}
                />
            </div>,
            <Footer1
                id="Footer1_0"
                key="Footer1_0"
                dataSource={Footer10DataSource}
                isMobile={this.state.isMobile}
            />,
        ];

        let realChildren = children;
        if (showDetail) {
            realChildren = childrenDetail;
        }
        return (
            <div
                className="templates-wrapper"
                style={{behavior:"smooth"}}
                ref={(d) => {
                    this.dom = d;
                }}
            >

                {/* 如果不是 dva 2.0 替换成 {children} start */}
                {realChildren}
                {/* 如果不是 dva 2.0 替换成 {children} end */}
            </div>
        );
    }
}
